import { styled, Tooltip as MuiTooltip, TooltipProps, tooltipClasses } from '@mui/material';
import React from 'react';

import { black, gray4 } from 'utils/color-styles';

export const Tooltip = styled(({ className, ...props }: TooltipProps) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#EBEBEB',
    color: black,
    maxWidth: 420,
    fontSize: 12,
    fontWeight: 400,
    border: `1px solid ${gray4}`,
    padding: 16,
  },
}));
